import { memo } from "react";
import SolarSystemLogo from "../SolarSystemLogo";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Image from "../../../../Elements/Image/Image";
import { ButtonAccessability } from "../../../../Elements/Button/Button";

import styles from "./styles.module.scss";

const Banner = memo(() => {
  const { getTextByKey, getHtmlByKey } = useContent();

  const handleExploreFeaturesClick = () => {
    // Scroll to element with id 'instant-delivery'
    const element = document.getElementById("instant-delivery");
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.bannerWrapper}>
      <SolarSystemLogo />
      <h1>
        {getTextByKey("your-file-management-ecosystem")
          .split(" ")
          .map((el: string) => (
            <span key={el}>{el}</span>
          ))}
      </h1>
      <p className={styles.description}>
        {getHtmlByKey("your-file-management-ecosystem-description")}
      </p>
      <ButtonAccessability onClick={handleExploreFeaturesClick}>
        <div className={styles.moreIconWrapper}>
          <p>{getTextByKey("explore-features")}</p>
          <Image name="features/arrow" ext="svg" className={styles.moreIcon} />
        </div>
      </ButtonAccessability>
      <Image name="features/banner_bg" ext="svg" className={styles.bannerBg} />
      <Image
        name="features/banner_wave"
        ext="svg"
        className={`${styles.bannerWave} ${styles.waveLeft}`}
      />
      <Image
        name="features/banner_wave"
        ext="svg"
        className={`${styles.bannerWave} ${styles.waveRight}`}
      />
    </div>
  );
});

export default Banner;
